(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportservice2/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/sportservice2/assets/javascripts/init.js');

'use strict';

const {
  ItemsMenu
} = svs.ui.ReactItemsMenu;
const {
  LinkItemRoute
} = svs.components.lbUtils.linkItemRoute;
const {
  BrowserRouter,
  Route,
  Link
} = ReactRouterDOM;
const {
  baseUrl
} = svs.core.data;
const {
  SportRadarIframe
} = svs.sportservice2;
const Start = () => React.createElement(React.Fragment, null, React.createElement(ItemsMenu, {
  centered: true,
  className: "sportservice-items-menu-wrapper",
  hiddenScrollbar: true
}, React.createElement(LinkItemRoute, {
  Component: props => React.createElement(Link, props),
  key: "Matcher/Events",
  label: "Matcher/Events",
  selectedOnPaths: ["".concat(baseUrl)],
  to: {
    pathname: "".concat(baseUrl),
    search: ''
  }
}), React.createElement(LinkItemRoute, {
  Component: props => React.createElement(Link, props),
  key: "Sport A-\xD6",
  label: "Sport A-\xD6",
  selectedOnPaths: ["".concat(baseUrl, "/sport")],
  to: {
    pathname: "".concat(baseUrl, "/sport"),
    search: ''
  }
})), React.createElement(Route, {
  component: SportRadarIframe,
  path: ["".concat(baseUrl, "/sport"), "".concat(baseUrl)]
}));
ReactDOM.render(React.createElement(BrowserRouter, null, React.createElement(Start, null)), document.getElementById('sportservice'));

 })(window);